import { CheckCircle2, XCircle, Info, AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/utils';

const VARIANTS = {
  success: { Icon: CheckCircle2,  color: 'var(--accent-stand)'   },
  error:   { Icon: XCircle,       color: 'var(--accent-red)'     },
  info:    { Icon: Info,          color: 'var(--accent-online)'  },
  warning: { Icon: AlertTriangle, color: 'var(--accent-yellow)'  },
};

export function Toast({ variant = 'info', title, description }) {
  const { Icon, color } = VARIANTS[variant] ?? VARIANTS.info;
  return (
    <div
      className={cn(
        'flex items-start gap-3 p-4 rounded-2xl',
        'bg-[var(--bg-L2)] border border-[var(--border-default)]',
        'shadow-[0_8px_24px_rgba(0,0,0,0.4)]',
        'min-w-[280px] max-w-[400px]',
        'animate-in slide-in-from-top fade-in duration-300'
      )}
      role="status"
      aria-live="polite"
    >
      <Icon size={20} style={{ color }} className="flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-[17px] font-semibold text-[var(--label-primary)] leading-snug">{title}</p>
        {description && (
          <p className="text-[13px] text-[var(--label-secondary)] mt-1">{description}</p>
        )}
      </div>
    </div>
  );
}
